<template>
    <div>
        <Transition
            enter-active-class="transition-all duration-200 ease-out"
            leave-active-class="transition-all duration-150 ease-in"
            enter-from-class="opacity-0 max-h-0"
            enter-to-class="opacity-100 max-h-[9999px]"
            leave-from-class="opacity-100 max-h-[9999px]"
            leave-to-class="opacity-0 max-h-0"
        >
            <div v-show="isExpanded" class="overflow-hidden">
                <slot />
            </div>
        </Transition>

        <div class="mt-2 flex" :class="toggleAlignClass">
            <button
                type="button"
                class="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:text-primary/80"
                @click="toggle"
            >
                <span>{{ isExpanded ? labelLess : labelMore }}</span>
                <svg
                    class="h-4 w-4 transition-transform duration-150"
                    :class="isExpanded ? 'rotate-180' : 'rotate-0'"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fill-rule="evenodd"
                        d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.937a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z"
                        clip-rule="evenodd"
                    />
                </svg>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

type Align = 'start' | 'center' | 'end';

const props = withDefaults(
    defineProps<{
        align?: Align;
        labelMore?: string;
        labelLess?: string;
    }>(),
    {
        align: 'center',
        labelMore: 'Show more',
        labelLess: 'Show less',
    }
);

const isExpanded = ref(false);

const toggleAlignClass = computed(() => {
    if (props.align === 'start') return 'justify-start';
    if (props.align === 'end') return 'justify-end';
    return 'justify-center';
});

const toggle = () => {
        isExpanded.value = !isExpanded.value;
};
</script>
